import { FC, useState } from 'react';
import PropTypes from 'prop-types';
import { GetUserProductResponse } from 'src/interfaces/userProduct/user-product';
import { Availability } from 'src/interfaces/new-technician/technician';
import { ServicePriceMasterView } from 'src/interfaces/masters/Price/price';
import { CustomerAddress, ICoupon } from 'src/interfaces/new-channel-partner/channelPartner';
import { Slot } from 'src/interfaces/repair-request/repair-request';
import { REPAIR_SERVICE_ID } from 'src/constants/repairRequest-constants';
import { IssuesCard } from './issueDetailsCard';
import { AppointmentSlot } from './requestAppointment';
import { RaiseRequestPaymentCard } from './raiseRequestPaymentCard';
import { RaiseRequestBasicInfoCard } from './requestBasicInfo';

interface RaiseRequestDetailsCardProps {
  selectedAddress: CustomerAddress;
  productDetails: GetUserProductResponse;
  setModeOfPayment : (data: string) => void;
  setSlotDetails: (data: Slot) => void;
  setServiceType: (data: string) => void;
  setCpId: (data: string) => void;
  setRequestFrom: (data: string) => void;
  setSourceOfInfo: (data: string) => void;
  setIssuesList: (data: string[]) => void;
  setCoupon: (data: ICoupon) => void;
}

export const RaiseRequestDetailsCard: FC<RaiseRequestDetailsCardProps> = (props) => {
  const { selectedAddress, productDetails,
    setServiceType, setIssuesList, setSlotDetails, setModeOfPayment,
    setRequestFrom, setSourceOfInfo, setCpId, setCoupon } = props;
  const [timeSlots, setTimeSlots] = useState<Availability[]>([]);
  const [servicePriceData,
    setServicePriceData] = useState<ServicePriceMasterView>();
  const [selectedServiceType, setSelectedServiceType] = useState<string>('');
  const [channelPartnerId, setChannelPartnerId] = useState<string>('');

  const getTimeSlotsData = (data: Availability[]) => {
    setTimeSlots(data);
  };

  const getServicePiceDetails = (data: ServicePriceMasterView) => {
    setServicePriceData(data);
  };

  const getCpId = (data: string) => {
    setChannelPartnerId(data);
    setCpId(data);
  };

  const getServiceType = (data: string) => {
    setSelectedServiceType(data);
    setServiceType(data);
  };

  return (
    <>
      <RaiseRequestBasicInfoCard
        selectedAddress={selectedAddress}
        productDetails={productDetails}
        setServicePrice={getServicePiceDetails}
        setSlots={getTimeSlotsData}
        setServiceType={getServiceType}
        setRequestFrom={setRequestFrom}
        setSourceOfInfo={setSourceOfInfo}
        setCpId={getCpId}
      />
      {
        selectedServiceType === REPAIR_SERVICE_ID
        && (
        <IssuesCard
          productId={productDetails?.product?.id}
          setIssuesList={setIssuesList}
        />
        )
      }
      {selectedAddress?.id && productDetails?.id
      && channelPartnerId && timeSlots?.length > 0
      && servicePriceData?.id && selectedServiceType === REPAIR_SERVICE_ID && (
        <>
          <AppointmentSlot
            timeSlots={timeSlots}
            setSlotDetails={setSlotDetails}
          />
          <RaiseRequestPaymentCard
            servicePriceDetails={servicePriceData}
            setModeOfPayment={setModeOfPayment}
            setCoupon={setCoupon}
          />
        </>
      )}
    </>
  );
};

RaiseRequestDetailsCard.propTypes = {
  // @ts-ignore
  productDetails: PropTypes.object,
  // @ts-ignore
  selectedAddress: PropTypes.object,
  setIssuesList: PropTypes.func,
  setServiceType: PropTypes.func,
  setRequestFrom: PropTypes.func,
  setSourceOfInfo: PropTypes.func,
  setSlotDetails: PropTypes.func,
  setCpId: PropTypes.func,
  setModeOfPayment: PropTypes.func,
  setCoupon: PropTypes.func
};
